if (!customElements.get('header-mobile-menu')) {
  customElements.define(
    'header-mobile-menu',
    class HeaderMobileMenu extends HTMLElement {
      constructor() {
        super();
        this.trigger = document.querySelector('.header-mobile__menu-icon');
        this.modal = this.querySelector('.header-mobile__menu-modal');
        this.header = document.querySelector('.header');
        this.closeButton = document.querySelector('.header-mobile__menu-close');
        this.mask = this.querySelector('.header-mobile__menu-modal-mask');

        const menuItems = document.querySelectorAll('.header-modal-menu-list-item-wrap');

        // 菜单展开点击监听
        menuItems.forEach((item) => {
          const title = item.querySelector('.header-modal-menu-list-item');
          const submenu = item.querySelector('.header-modal-menu-list-submenu');

          title.addEventListener('click', function () {
            item.classList.toggle('header-modal-menu-list-item-open');
            // if (!item.classList.contains('header-modal-menu-list-item-open')) {
            //   item.classList.add('header-modal-menu-list-item-open');
            // }
          });
        });

        const closeOtherSubMenu = () => {
          const items = document.querySelectorAll('.header-modal__submenu-item');
          items.forEach((item) => {
            item.classList.remove('header-modal__submenu-item-active');
          });
        };

        const menuList = document.querySelector('.header-modal__menu-list');
        menuList.addEventListener('click', (e) => {
          const subMenu = e.target.closest('.header-modal__submenu-item');
          if (subMenu) {
            if (!subMenu.classList.contains('header-modal__submenu-item-active')) {
              closeOtherSubMenu();
            }
            subMenu.classList.toggle('header-modal__submenu-item-active');
            return;
          }

          const item = e.target.closest('.header-modal__menu-list-item');
          if (item && !item.classList.contains('header-modal__menu-list-item-active')) {
            item.classList.add('header-modal__menu-list-item-active');
          }
        });

        this.querySelectorAll('.header-modal__menu-list-item').forEach((item) => {
          const backButton = item.querySelector('.header-modal__submenu-back');
          if (backButton) {
            backButton.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              console.log('item =', item);
              item.classList.remove('header-modal__menu-list-item-active');
            });
          }
        });
      }

      connectedCallback() {
        this.trigger.addEventListener('click', this.onModalOpenClick.bind(this));
        this.closeButton.addEventListener('click', this.close.bind(this));
        this.mask.addEventListener('click', this.close.bind(this));
      }

      disconnectedCallback() {
        this.trigger.removeEventListener('click', this.onModalOpenClick.bind(this));
        this.closeButton.removeEventListener('click', this.close.bind(this));
        this.mask.removeEventListener('click', this.close.bind(this));
      }

      onModalOpenClick() {
        this.modal.classList.toggle('header-mobile__menu-modal-open');
        this.header.setAttribute('data-details', 'open');
      }

      close() {
        this.modal.classList.remove('header-mobile__menu-modal-open');
        this.header.removeAttribute('data-details');
      }
    }
  );
}
